import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Modal, ModalConfig, ModalType } from '@app/shared/models/modal.model';
import { EventManager } from '@app/shared/utils/event-manager';
import { SharedModule } from '@shared/shared.module';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonComponent } from '@app/shared/components/button/button.component';
import { LogLevel } from '@shared/utils/logger/log-entry';
import { NavigationButtonComponent } from '@app/shared/components/navigation-button/navigation-button.component';
import { WebOptionsComponent } from './web-options/web-options.component';
import { PlayerOptionsComponent } from './player-options/player-options.component';
import { AdvancedOptionsComponent } from './advanced-options/advanced-options.component';
import { PlayGamesOptionsComponent } from './play-games-options/play-games-options.component';
import { TesterModalFacade } from './tester-modal.facade';
import { TakeUntilDestroy } from '@app/shared/decorators/take-until-destroy.decorator';

@TakeUntilDestroy
@Component({
  standalone: true,
  imports: [
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    ButtonComponent,
    NavigationButtonComponent,
    WebOptionsComponent,
    PlayerOptionsComponent,
    AdvancedOptionsComponent,
    PlayGamesOptionsComponent,
  ],

  selector: 'slotcom-tester-modal',
  templateUrl: './tester-modal.component.html',
  styleUrls: ['./tester-modal.component.scss'],
})
export class TesterModalComponent implements OnInit {
  testerModalData = inject<ModalConfig>(MAT_DIALOG_DATA);
  private eventManager = inject(EventManager);
  private testerModalFacade = inject(TesterModalFacade);

  activeTab: 'webOptions' | 'playerOptions' | 'advancedOptions' | 'playGamesOptions' = 'playerOptions';

  ngOnInit(): void {
    this.testerModalFacade.init(this.testerModalData);
  }

  protected readonly LogLevel = LogLevel;

  setPanelTab(tab: 'webOptions' | 'playerOptions' | 'advancedOptions' | 'playGamesOptions') {
    this.activeTab = tab;
  }

  closeModal() {
    this.eventManager.closeModal(new Modal(this.testerModalData.id, ModalType.View, this.testerModalData));
  }
}
